import Loadable from '../../components/Loadable';
import { lazy } from 'react';

const LeadManagement = Loadable(lazy(() => import('./LeadManagement')));
const CustomerManagement = Loadable(lazy(() => import('./CustomerManagement')));
const FollowUpManagement = Loadable(lazy(() => import('./FollowUpManagement')));

const crmRoutes = [
    {
        path: '/crm/leads',
        element: <LeadManagement />,
    },
    {
        path: '/crm/quality-leads',
        element: <LeadManagement isQualityLeadView={true} />,
    },
    {
        path: '/crm/wrong-leads',
        element: <LeadManagement isWrongLeadView={true} />,
    },
    {
        path: '/crm/customers',
        element: <CustomerManagement />,
    },
    {
        path: '/crm/status',
        element: <LeadManagement isStatusView={true} />,
    },
    {
        path: '/crm/followups',
        element: <FollowUpManagement />,
    },
];

export default crmRoutes;
